import { AppBar, type AppBarProps } from '@health/booking-sdk-react/components/AppBar'
import '@health/booking-sdk-react/style.css'
import { ptOptions } from 'app/src/shared/helpers'
import { type ReactElement } from 'react'

export function AppBarSdk(props: AppBarProps): ReactElement {
  return <AppBar ptOptions={ptOptions.ptOptions} {...props} />
}
